export const SET_GENERAL_TEXT = 'SETTINGS_TEXTS_SET_GENERAL_TEXT'
export const SET_DOWNLOAD_EVERYTHING_TEXT = 'SETTINGS_TEXTS_SET_DOWNLOAD_EVERYTHING_TEXT'
export const SET_RUN_WITH_LOGS_TEXT = 'SETTINGS_TEXTS_SET_RUN_WITH_LOGS_TEXT'
export const SET_RUN_WITH_DX9_TEXT = 'SETTINGS_TEXTS_SET_RUN_WITH_DX9_TEXT'
export const SET_MINIMIZE_TO_TRAY_TEXT = 'SETTINGS_TEXTS_SET_MINIMIZE_TO_TRAY_TEXT'
export const SET_LANGUAGE_TEXT = 'SETTINGS_TEXTS_SET_LANGUAGE_TEXT'
export const SET_RESET_TEXT = 'SETTINGS_TEXTS_SET_RESET_TEXT'
export const SET_FORGET_ALL_ACCOUNTS_TEXT = 'SETTINGS_TEXTS_SET_FORGET_ALL_ACCOUNTS_TEXT'
export const SET_FORGET_ALL_ACCOUNTS_TOOLTIP_TEXT =
    'SETTINGS_TEXTS_SET_FORGET_ALL_ACCOUNTS_TOOLTIP_TEXT'
export const SET_SHARED_CACHE_SETTINGS_TEXT = 'SETTINGS_TEXTS_SET_SHARED_CACHE_SETTINGS_TEXT'
// export const SET_RESET_TO_DEFAULTS_TEXT = 'SETTINGS_TEXTS_SET_RESET_TO_DEFAULTS_TEXT'
export const SET_MANAGE_API_PERMISSIONS_TEXT = 'SETTINGS_TEXTS_SET_MANAGE_API_PERMISSIONS_TEXT'
export const SET_TEST_SERVERS_TEXT = 'SETTINGS_TEXTS_SET_TEST_SERVERS_TEXT'
export const SET_LAUNCH_OPTIONS_TEXT = 'SETTINGS_TEXTS_SET_LAUNCH_OPTIONS_TEXT'
export const SET_AUTO_LAUNCH_ON_LOGIN_TEXT = 'SETTINGS_TEXTS_SET_AUTO_LAUNCH_ON_LOGIN_TEXT'
export const SET_AUTO_LAUNCH_ON_LOGIN_TOOLTIP_TEXT =
    'SETTINGS_TEXTS_SET_AUTO_LAUNCH_ON_LOGIN_TOOLTIP_TEXT'
export const SET_AUTO_LAUNCH_ON_STARTUP_TEXT = 'SETTINGS_TEXTS_SET_AUTO_LAUNCH_ON_STARTUP_TEXT'
export const SET_AUTO_LAUNCH_ON_STARTUP_TOOLTIP_TEXT =
    'SETTINGS_TEXTS_SET_AUTO_LAUNCH_ON_STARTUP_TOOLTIP_TEXT'
export const SET_LAUNCH_DELAY_TEXT = 'SETTINGS_TEXTS_SET_LAUNCH_DELAY_TEXT'
export const SET_SECONDS_TEXT = 'SETTINGS_TEXTS_SET_SECONDS_TEXT'
export const SET_CONFIRM_FORGET_TEXT = 'SETTINGS_TEXTS_SET_CONFIRM_FORGET_TEXT'
export const SET_SETTING_SAVED_TITLE_TEXT = 'SETTINGS_TEXTS_SET_SETTING_SAVED_TITLE_TEXT'
// export const SET_SETTING_SAVED_MESSAGE_TEXT = 'SETTINGS_TEXTS_SET_SETTING_SAVED_MESSAGE_TEXT'
export const SET_LAYOUT_TEXT = 'SETTINGS_TEXTS_SET_LAYOUT_TEXT'
export const SET_LAYOUT_DEFAULT_TEXT = 'SETTINGS_TEXTS_SET_LAYOUT_DEFAULT_TEXT'
export const SET_LAYOUT_RIGHT_TEXT = 'SETTINGS_TEXTS_SET_LAYOUT_RIGHT_TEXT'
export const SET_LAYOUT_LEFT_TEXT = 'SETTINGS_TEXTS_SET_LAYOUT_LEFT_TEXT'
export const SET_TEXTS = 'SETTINGS_TEXTS_SET_TEXTS'



// WEBPACK FOOTER //
// ./src/features/Settings/data/texts/constants.js